import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsObjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object',
	path: '/jira/servicedesk/assets/object/:objectId',
};
